import AbstractLayerManager from './AbstractLayerManager';

export default class RefreshableLoopingTileLayerManager extends AbstractLayerManager {
	constructor(myKey, instance, layerType, url, options, sublayers) {
		super(myKey, instance);
		
		this.options.hasPanRefresh = false;
		this.options.hasAutoRefresh = true;
		this.layerType = layerType;
		this.url = url;
		this.dataOptions = (options || {});

		this.layers = [];
		this.layerLoadingStack = [];
		this.currentFrameId = null;
		this.preloading = false;
		this.myTimer = null;

		// TODO TESTING
		this.urls = [
			"https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA_60m-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}",
			"https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA_50m-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}",
			"https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA_40m-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}",
			"https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA_30m-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}",
			"https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA_20m-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}",
			"https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA_10m-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}",
			"https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}"
		];
		this.dataOptions = {
			"subdomains": "1234",
			"layers": "Radar_NA_RALA",
			"tms": true,
			"transparent": true,
			"opacity": 0.0,
			"time": "{{unixtime}}",
			"zIndex": 999,
			"detectRetina": true,
			"tileSize": 512,
			"keepBuffer": 1,
		};

	}

	/* @override */
	attachLayer() {
		if(this.isAttached()) return true;

		// Set any dynamic options
		if(this.dataOptions.time) this.dataOptions.time = (new Date()).getTime();

		// On attach, set visible layer to most recent (last in stack)
		this.currentFrameId = this.urls.length - 1;
		this.url = this.urls[this.currentFrameId];

		for(const [i, v] of this.urls.entries()) {
			if(this.layerType === 'wms') {
				this.layers[i] = new L.TileLayer.WMS(v, this.dataOptions);
			} else if(this.layerType === 'wmts') {
				this.layers[i] = new L.TileLayer.WMTS(v, this.dataOptions);
			} else {
				this.layers[i] = new L.TileLayer(v, this.dataOptions);
			}
			// Initialize layer status
			this.layerLoadingStack[i] = true;

			// Add invisible layers to map instance
			this.inst.map.addLayer(this.layers[i]);

			// Set layer events
			this.layers[i].on('loading', () => {
				this.setFrameLoadingStatus(i, true);
			});
			this.layers[i].on('load', () => {
				this.setFrameLoadingStatus(i, false);
			});
		}
		
		if(this.options.hasPanRefresh) this.inst.mapMoveListeners[this.id] = this.id;
		if(this.options.hasAutoRefresh) this.inst.autoUpdateListeners[this.id] = this.id;

		/*
		this.layer.on('loading', () => {
			this.inst.setLoadingMonitor(this.id, true);
		});
		this.layer.on('load', () => {
			this.inst.setLoadingMonitor(this.id, false);
		});
		*/

		this.startLooping();
	}
	
	refreshLayer() {
		this.setOption('time', (new Date()).getTime());
		for(var i = 0; i < this.layers.length; i++) {
				this.layers[i].redraw();
		}
	}

	setOptions(o) {
		for(const [k, v] of Object.entries(o)) {
			this.setOption(k, v);
		}
	}

	setOption(k, v) {
		// FIXME could conflict with WMS Params...
		for(var i = 0; i < this.layers.length; i++) {
			if(typeof this.layers[i].setParams === 'function') {
				let o = {};
				o[k] = v;
				this.layers[i].setParams(o);
			}
			this.layers[i].options[k] = v;
		}
	}

	startLooping() {
		// preload frames
		var resp = this.getFrameStatus();
		console.log("startLooping", resp);

		// TODO force-reload if any sublayers are out of date

		if(resp.loading > 0) {
			this.preloading = true;
			return false;
		} else {
			this.preloading = false;
			return this.goLooping();
		}
	}

	stopLooping() {
		if(this.myTimer) clearTimeout(this.myTimer);
		this.myTimer = null;
	}

	goLooping() {
		if(this.preloading) return false; // dont allow looping if not currently loaded

		this.showNextFrameAndWait();
		return true;
	}

	showFrame(id) {
		this.currentFrameId = id;
		this.url = this.urls[id];
		this.inst.layers[this.id] = this.layers[id];

		// TODO do we need requestAnimationFrame?
		for(var i = 0; i < this.layers.length; i++) {
			if(i == id) {
				this.layers[i].setOpacity(0.75);
			} else {
				this.layers[i].setOpacity(0.0);
			}
		}
	}

	showNextFrameAndWait() {
		// Compute next frame, or wait & loop to beginning
		var nextFrameId = this.currentFrameId + 1;
		var lastStackId = this.layers.length - 1;
		var nextWait = 600; // ms
		//console.log(nextFrameId, lastStackId);
		if(nextFrameId > lastStackId) {
			// At end of stack, reset loop
			this.showFrame(0);
		} else if(nextFrameId == lastStackId) {
			// Next frame is the last one, pause on it longer
			this.showFrame(nextFrameId);
			nextWait = 2000;
		} else {
			this.showFrame(nextFrameId);
		}

		var self = this;
		this.myTimer = setTimeout(function() {
			self.showNextFrameAndWait();
		}, nextWait);
	}

	getFrameStatus() {
		var pendingCount = 0;
		for(const loading of this.layerLoadingStack) {
			if(loading) pendingCount++;
		}
		return {"steps": this.urls.length, "loading": pendingCount, "loaded": (this.urls.length - pendingCount)};
	}

	setFrameLoadingStatus(layer_id, status) {
		this.layerLoadingStack[layer_id] = status;
		this.frameLoadingStatusCallback(this.getFrameStatus());
	}

	frameLoadingStatusCallback(status) {
		console.log(status, this.layerLoadingStack);
		if(status.loading == 0 && this.preloading) {
			// Fully loaded, Immediately begin looping
			this.preloading = false;
			this.goLooping();
		}
	}
}
